exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter {\n  vertical-align: middle;\n  width: 100%;\n  text-align: left; }\n  .filter.badge {\n    display: block;\n    color: #c7c8ca; }\n    .filter.badge:hover {\n      background-color: rgba(167, 200, 82, 0.5); }\n  .filter.active {\n    color: #626b6f; }\n    .filter.active:hover {\n      background-color: rgba(167, 200, 82, 0.5); }\n  .filter .svg-icon {\n    vertical-align: middle;\n    width: 25px; }\n  .filter span {\n    vertical-align: middle;\n    padding: 5px; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  .filter > span {\n    display: none; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/legend-panel.component.scss
// module id = ../../../../../src/app/common/legend-panel.component.scss
// module chunks = main